module.exports = __webpack_public_path__ + "static/media/img_wear-classic.9ad68241.png";